<a
  wlAutomationId="back-button-sidebar"
  *wlGenericLink="backLink; extras: { queryParamsHandling: 'preserve' }"
  class="btn btn-outline-secondary btn-sm"
  [class.btn-icon]="!backLink.title"
  queryParamsHandling="preserve"
  [wlTrackLink]="backLink.title"
  [trackLinkInfo]="{
    rendering: rendering,
    field: backLink.title,
    linkurl: backLink.href,
  }"
  aria-label="Terug naar het overzicht"
  wlCSCapture
>
  <fa-icon icon="arrow-left" size="lg" [class.me-1]="backLink.title"></fa-icon>
  <span>{{ backLink.title }}</span>
</a>
